import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}
export function GoogleAnalytics() {
  useEffect(() => {
    // Load gtag.js script
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-C924K521GZ';
    script.async = true;
    document.head.appendChild(script);
    // Initialize dataLayer and gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer.push(args);
    };
    window.gtag('js', new Date());
    window.gtag('config', 'G-C924K521GZ');
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return null;
}